<template>
  <div class="VDataTable">
    <v-data-table
      ref="tableRemote"
      class="custom-table"
      :items="items"
      :headers="tableHeaders"
      :page.sync="pagination.currentPage"
      :itemsPerPage.sync="perpage"
      :sortBy.sync="sortBy"
      :mustSort="true"
      :sortDesc.sync="sortDesc"
      :footerProps="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: $t('controls.rowsPerPage'),
        showFirstLastPage: true,
      }"
      :loading="loading"
      :loadingText="$t('generic.loading')"
      :serverItemsLength="pagination.totalElementCount"
      :mobileBreakpoint="0"
      :height="heightDataTable"
      fixedHeader
      :data-cy="dataCy"
      v-bind="$attrs"
      v-on="$listeners"
      @click:row="onSelect"
    >
      <template
        v-if="showHeader"
        #top
      >
        <div
          style="margin: 0px 20px;"
          class="blocHeader"
        >
          <div v-if="$attrs.isLabAnalysisTemplate">
            <slot name="extraHeader" />
          </div>
          <v-toolbar flat>
            <div class="d-lg-flex align-center w-100">
              <v-toolbar-title
                class="d-flex my-2 my-lg-0 overflow-visible pl-2 justify-space-between titleBar"
                style="width: 100%"
              >
                <span style="font-weight: 700 !important">{{ title }}</span>
                <ActionButtons
                  v-if="iconHeader"
                  :actionButtons="getActionButtons"
                  isInDataTable
                  :class="classButton"
                />
              </v-toolbar-title>

              <v-spacer />
              <slot name="extraContent" />
              <template v-if="displayeFilter">
                <v-spacer />
                <v-select
                  :items="filterItem.length ? filterItem : templateTypes"
                  class="mt-3"
                  chips
                  clearable
                  :label="filterPlaceHolder ? filterPlaceHolder : $t('forms.labels.templateType')"
                  prependIcon="filter_list"
                  dense
                  :multiple="multiple"
                  itemValue="key"
                  itemText="name"
                  @input="$emit('type-changed', $event)"
                />
              </template>
            </div>
          </v-toolbar>
          <v-col
            v-if="isExportable && items.length"
            cols="12"
            class="boxCSV"
          >
            <CsvExport
              :data="items"
              :rowHeaders="exportHeaders"
            />
          </v-col>

          <template>
            <slot name="SearchWithFilters" />
            <!-- S'il n'y a pas de filtre (avec isSearchable de passé en parametre) , on affiche la barre de recherche sans filtre -->
            <div v-if="isSearchable && !$slots.SearchWithFilters">
              <SearchWithFilters
                ref="searchInput"
                :filters="[]"
                :searchPlaceholder="$t('charts.searchBy')"
                :filterName="'name'"
                @onSearch="onSearch"
              />
            </div>
          </template>

          <v-row class="mx-0">
            <v-col
              v-for="(filter, index) in mutableSwitchFilters"
              :key="index"
              md="3"
              sm="12"
              class="switch--container"
            >
              <v-switch
                v-model="filter.value"
                hideDetails
                class="mt-0 ml-3"
                :disabled="loading"
                :label="filter.label"
                @change="filterChange"
              />
            </v-col>
          </v-row>
        </div>

        <template>
          <slot name="buttonsLineHeader" />
        </template>
      </template>

      <template
        v-if="startIconName"
        v-slot:item.icon
      >
        <div class="startIconContainer">
          <v-icon color="#26384B">
            {{ startIconName }}
          </v-icon>
        </div>
      </template>
      <template
        v-if="itemActions"
        v-slot:item.action="{ item }"
      >
        <div :class="{ 'd-flex justify-end ': isWorkOrderTemplate && !!site.id }">
          <v-btn
            v-if="isWorkOrderTemplate && !isWoTemplateService"
            color="primary"
            class="save-btn mr-5 text-white"
            @click="$emit('start-workOrder', item)"
          >
            {{ $t('forms.btn.start') }}
          </v-btn>

          <div>
            <v-menu
              nudgeRight="205"
              nudgeBottom="35"
              minWidth="100"
            >
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="action-buttons"
                >
                  <v-btn
                    color="primary"
                    fab
                    xSmall
                    :data-cy="cyData.vTableRemote.buttons.actionBtn"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </div>
              </template>
              <!-- WOTemplate view or LABAnalysis view -->
              <div v-if="isWorkOrderTemplate || $attrs.isLabAnalysisTemplate">
                <v-list :data-cy="cyData.vTableRemote.buttons.menuActions.menu">
                  <template v-for="(action,idx) in itemActions">
                    <v-list-item
                      v-if="canShow(item, action, isWorkOrderTemplate)"
                      :key="idx"
                      :data-cy="`${action.icon}-${idx}`"
                      @click.prevent.stop="$emit('iconAction', item, action)"
                    >
                      <v-list-item-content>
                        <v-list-item-title :style="`${action.iconAndTextColor ? `color:${action.iconAndTextColor}` : ''}`">
                          <v-icon
                            :style="`${action.iconAndTextColor ? `color:${action.iconAndTextColor}` : ''}`"
                            v-text="action.icon"
                          />
                          {{ action.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </div>
              <!-- Other view -->
              <div v-else>
                <div v-if="isCustomIcon">
                  <v-list :data-cy="cyData.vTableRemote.buttons.menuActions.menu">
                    <template v-for="(action,idx) in itemActions">
                      <v-list-item
                        v-if="validateCustomIcon(item, action)"
                        :key="idx"
                        :data-cy="`${action.icon}-${idx}`"
                        @click.prevent.stop="$emit('iconAction', item, action)"
                      >
                        <v-list-item-content>
                          <v-list-item-title
                            :style="`${action.iconAndTextColor ? `color:${action.iconAndTextColor}` : ''}`"
                          >
                            <v-icon
                              :style="`${action.iconAndTextColor ? `color:${action.iconAndTextColor}` : ''}`"
                              v-text="action.icon"
                            />
                            {{ action.name }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </div>
                <div v-else>
                  <v-list :data-cy="cyData.vTableRemote.buttons.menuActions.menu">
                    <v-list-item
                      v-for="(action,idx) in itemActions"
                      :key="idx"
                      :data-cy="`${action.icon || action}-${idx}`"
                      @click.prevent.stop="$emit('iconAction', item, action)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-icon v-text="action" />
                          {{ action }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </div>
            </v-menu>
          </div>
        </div>
      </template>

      <template
        v-for="(_, slot) of $scopedSlots"
        v-slot:[slot]="scope"
      >
        <slot
          :name="slot"
          v-bind="scope"
        />
      </template>
      <template v-slot:body.append>
        <slot name="withInfiniteScroll" />
      </template>
      <template
        v-if="withCustomSelect"
        v-slot:item.data-table-select="{ item, isSelected, select }"
      >
        <v-checkbox
          :value="isSelected"
          :disabled="item.status.key === 'HOLD'"
          @input="select(!isSelected)"
        />
      </template>
    </v-data-table>
    <div
      v-if="isWindowsOS && !$vuetify.breakpoint.smAndDown && scrollWidth && canScroll('left')"
      class="d-flex justify-center align-center btn--container"
      :style="`left: ${leftPosition}%`"
    >
      <v-btn
        icon
        color="white"
        xLarge
        @click="scrollTo('left')"
      >
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
    </div>
    <div
      v-if="isWindowsOS && !$vuetify.breakpoint.smAndDown && scrollWidth && canScroll('right')"
      class="d-flex justify-center align-center btn--container"
      style="right: 2%;"
    >
      <v-btn
        icon
        color="white"
        xLarge
        @click="scrollTo('right')"
      >
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import { mapGetters } from 'vuex';
import { isWindows } from 'get-os-name';
import CsvExport from '@/components/shared/widgets/CsvExport';
import templateType from '@/constants/workOrderTemplateTypes';
import { vTableRemote } from '@/aq-data-cy.json';
import autofocus from '@/utilities/directives/autofocus';
import SearchWithFilters from '@/components/shared/SearchWithFilters.vue';
import ActionButtons from '../ActionButtons.vue';
import VCheckbox from '../widgets/forms/VuetifyInputs/VCheckbox.vue';


export default {
    directives: {
        autofocus,
    },
    components: {
        ActionButtons,
        CsvExport,
        VCheckbox,
        SearchWithFilters,
    },
    props: {
        sortBy: {
            type: String,
            default: 'name',
        },
        items: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
            default: null,
        },
        sortableColumns: {
            type: Array,
            default: () => [],
        },
        iconHeader: {
            type: String,
            default: null,
        },
        itemActions: {
            type: Array,
            default: () => [],
        },
        isSelectable: {
            type: Boolean,
            default: false,
        },
        isSearchable: {
            type: Boolean,
            default: true,
        },
        pagination: {
            type: Object,
            required: true,
        },
        elementsPerPage: {
            type: Number,
            default: 25,
        },
        switchFilters: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        showHeader: {
            type: Boolean,
            default: true,
        },
        headers: {
            type: Array,
            required: true,
        },
        isWorkOrderTemplate: {
            type: Boolean,
            default: false,
        },
        isCustomIcon: {
            type: Boolean,
            default: false,
        },
        displayeFilter: {
            type: Boolean,
            default: false,
        },
        filterItem: {
            type: Array,
            default: () => [],
        },
        filterPlaceHolder: {
            type: String,
            default: null,
        },
        isExportable: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: true,
        },
        isInfinitScroll: {
            type: Boolean,
            default: false,
        },
        headerActionButtons: {
            type: Array,
            default: () => [],
        },
        withCustomSelect: {
            type: Boolean,
            default: false,
        },
        startIconName: {
            type: String,
            default: '',
        },
        centerColumns: {
            type: Array,
            default: () => ([]),
        },
        endColumns: {
            type: Array,
            default: () => ([]),
        },
        notSortableColumns: {
            type: Array,
            default: () => ([]),
        },
        dataCy: {
            type: String,
            default: '',
        },
        heightAuto: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            switchValue: this.switch,
            search: null,
            sortDesc: false,
            page: null,
            perpage: this.elementsPerPage,
            mutableSwitchFilters: this.switchFilters,
            debouncedSendQueryParams: debounce(this.sendQueryParams, 500),
            templateTypes: [templateType.TEAM, templateType.PERSONAL],
            isWoTemplateFromService: false,

            // height of some elements get on Dom

            mainTitleHeight: 0,
            breadcrumbsHeight: 0,
            statusBarHeight: 0,
            heightHeader: 0,
            heightHeader2: 0,
            titlesOfDataTable: 0,
            // scroll buttons
            scrollWidth: 0,
            elementWidth: 0,
            scrollAmount: 0,
        };
    },
    computed: {
        ...mapGetters([
            'hasRole',
            'currentMember',
            'site',
            'isMini',
            'userID',
        ]),
        exportHeaders() {
            return this.headers.map(column => column.value);
        },
        order() {
            const sortLabel = `${this.sortBy}_${((this.sortDesc) ? 'desc' : 'asc')}`;
            return this.$options.filters.lowercase(sortLabel);
        },
        currentPage() {
            return this.pagination.currentPage;
        },
        getActionButtons() {
            return this.headerActionButtons?.length ? this.headerActionButtons : [
                {
                    label: this.$t('sitePage.add'),
                    action: () => this.$emit('iconAction', this.iconHeader),
                    icon: this.iconHeader,
                    displayIcon: true,
                    color: 'primary',
                    desktopExtraClass: 'iconAction',
                },
            ];
        },
        tableHeaders() {
            const headers = [...this.headers];

            if (this.itemActions.length > 0) {
                headers.push({
                    text: this.isWorkOrderTemplate ? '' : this.$t('controls.actions'),
                    value: 'action',
                    sortable: false,
                });
            }
            return headers.map(item => {
                let align = 'start';
                if (this.centerColumns.includes(item.value)) {
                    align = 'center';
                }
                if (this.endColumns.includes(item.value)) {
                    align = 'end';
                }
                const className = item.class ? item.class : '';
                const sortable = item.sortable === false ? false : !this.notSortableColumns.includes(item.value);
                return {
                    ...item,
                    align,
                    sortable,
                    class: sortable && !this.centerColumns.includes(item.value) ? className : `sortTable ${className}`,
                };
            });
        },
        leftPosition() {
            return this.isMini ? 5 : 20;
        },
        isWindowsOS() {
            return isWindows();
        },
        classButton() {
            if (window.innerWidth > 600) return 'ml-auto ml-lg-0';
            return '';
        },
        cyData() {
            return {
                vTableRemote,
            };
        },
        heightDataTable() {
            if (this.heightAuto) return 'auto';
            /* Pour définir la hauteur du tableau, je prends la hauteur de l'écran disponible et j'enlève les hauteur des différents blocs de menu */

            // eslint-disable-next-line max-len
            const heightDataTable = this.$vuetify.breakpoint.height - this.mainTitleHeight - this.breadcrumbsHeight - this.statusBarHeight - this.heightHeader - this.heightHeader2 - this.titlesOfDataTable;
            const breakPointTablet = 960;
            const breakPointscreen = 1263;
            const marginsForTablet = 45;
            const marginsForScreen = 80;
            if (window.innerWidth < breakPointTablet) {
                return heightDataTable - marginsForTablet;
            }
            if (window.innerWidth < breakPointscreen) {
                return heightDataTable - marginsForScreen;
            }

            return heightDataTable;
        },
        isWoTemplateService() {
            const url = new URL(window.location.href);
            return url.pathname === '/services/workOrdersTemplate';
        },
    },
    watch: {
        order(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.sendQueryParams();
            }
        },
        perpage(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.sendQueryParams();
            }
        },
        currentPage(newValue, oldValue) {
            if (oldValue) {
                if (newValue !== oldValue && !this.isInfinitScroll) {
                    this.sendQueryParams();
                }
            }
        },
        switchFilters: {
            handler(filters) {
                this.mutableSwitchFilters = filters;
            },
            deep: true,
        },

        '$vuetify.breakpoint.width': function () {
            this.setHeightForOverflow();
        },
        '$vuetify.breakpoint.height': function () {
            this.setHeightForOverflow();
        },

    },
    async mounted() {
        this.initTemplateType();
        this.setHeightForOverflow();
        // horizontal scroll feature
        const content = document.querySelector('.v-data-table__wrapper');
        this.checkScroll(content);
        if (this.isSearchable) {
            const input = this.$refs.searchInput.$el.querySelector('input');
            if (input) input.focus();
        }
    },

    methods: {
        onSelect(item) {
            if (this.isSelectable) {
                this.$emit('send-item', item);
            }
        },
        buildQueryParams() {
            const toLowercaseSortableColumns = this.sortableColumns.map(item => this.$options.filters.lowercase(item));
            const isOrderValid = toLowercaseSortableColumns.includes(this.$options.filters.lowercase(this.sortBy));
            const queryParams = {
                page: this.pagination.currentPage,
                perpage: this.perpage,
                order: isOrderValid ? this.order : null,
            };

            if (this.isSearchable) {
                queryParams.search = this.search;
            }
            return queryParams;
        },
        sendQueryParams() {
            this.$emit('sendQueryParams', this.buildQueryParams());
        },

        isAdminOrManager() {
            return ((this.hasRole('manager') || this.hasRole('administrator')));
        },
        canShow(item, action, isWorkOrderTemplate) {
            if (isWorkOrderTemplate) {
                // WOTemplate
                if (this.isAdminOrManager()) return true;
                switch (item.type) {
                    case templateType.TEAM:
                        if (action.icon === 'content_copy') { return true; }
                        break;
                    case templateType.SITE:
                        return (action.icon !== 'content_copy' ? item.createdUserId === this.currentMember.id : true) || this.hasRole('salesRepresentative');
                    case templateType.PERSONAL:
                        return item.createdUserId === this.currentMember.id;
                    default:
                        break;
                }
            } else {
                // labAnalysis
                switch (item.status.key) {
                    case 'TODO':
                    case 'WAITING':
                    case 'REMOVED':
                        return true;
                    case 'HOLD':
                        return action.mode === 'update' || action.mode === 'delete';
                    case 'SENT':
                        return action.mode === 'waiting' || action.mode === 'delete';
                    default:
                        return false;
                }
            }
            return false;
        },
        validateCustomIcon(item, action) {
            if (!action.customValidationProperty) return true;
            if (item[action.customValidationProperty]) {
                return action.showOncustomValidationProperty;
            }
            if (!action.showOncustomValidationProperty) return true;

            return false;
        },
        initTemplateType() {
            if (this.site.id) {
                this.templateTypes.push(templateType.SITE);
            }
        },
        filterChange(isActivated) {
            this.$emit('change-switch-filters', [{ value: isActivated }], this.buildQueryParams());
        },
        canScroll(direction) {
            if (direction === 'right') {
                return this.scrollWidth !== 0 && (this.elementWidth + this.scrollAmount) < this.scrollWidth;
            }
            // left
            return this.scrollAmount > 0;
        },
        checkScroll(element) {
            const canScroll = element ? element.scrollWidth > element.clientWidth : false;
            if (canScroll) {
                this.scrollWidth = element.scrollWidth;
                this.elementWidth = element.clientWidth;
            }
        },
        scroll() {
            const content = document.querySelector('.v-data-table__wrapper');
            content.scrollTo({
                left: this.scrollAmount,
                behavior: 'smooth',
            });
        },
        scrollTo(direction) {
            if (direction === 'right') {
                if (this.elementWidth + this.scrollAmount + 200 > this.scrollWidth) {
                    this.scrollToEnd();
                    return;
                }
                this.scrollAmount += 200;
            } else {
                if (this.scrollAmount - 200 < 0) {
                    this.scrollToBegining();
                    return;
                }
                this.scrollAmount -= 200;
            }
            this.scroll();
        },
        scrollToEnd() {
            const diff = this.scrollWidth - (this.elementWidth + this.scrollAmount);
            this.scrollAmount += diff;
            this.scroll();
        },
        scrollToBegining() {
            this.scrollAmount = 0;
            this.scroll();
        },
        onSearch(value) {
            this.search = value;
            this.debouncedSendQueryParams();
        },
        setHeightForOverflow() {
            // Hauteur du menu principal
            this.mainTitleHeight = document.getElementsByClassName('v-slide-group__wrapper')[0] ? document.getElementsByClassName('v-slide-group__wrapper')[0].offsetHeight : 0;
            // Hauteur du breadscrumbs (fil d'ariane)
            this.breadcrumbsHeight = document.getElementsByClassName('v-breadcrumbs')[0] ? document.getElementsByClassName('v-breadcrumbs')[0].offsetHeight : 0;
            // Hauteur de la barre de statut (elle n'est présente que dans Field Service => Work Orders)
            this.statusBarHeight = document.getElementsByClassName('statusBar')[0] ? document.getElementsByClassName('statusBar')[0].offsetHeight + 20 : 0;
            // Hauteur du bloc d'en-tête (contenant le titre et les boutons de recherche et de filtres)
            this.heightHeader = document.getElementsByClassName('blocHeader')[0] ? document.getElementsByClassName('blocHeader')[0].offsetHeight : 0;
            // Hauteur de la barre d'action (Elle n'est présente que dans Laboratory => Analysis Requests)
            this.heightHeader2 = document.getElementsByClassName('analysisRequest-action-bar')[0] ? document.getElementsByClassName('analysisRequest-action-bar')[0].offsetHeight + 20 : 0;
            // Hauteur des titres des colonnes de la table de données
            this.titlesOfDataTable = document.getElementsByClassName('v-data-table-header')[0] ? document.getElementsByClassName('v-data-table-header')[0].offsetHeight : 0;
        },
    },
};
</script>

<style scoped lang="scss">
  .boxCSV {
    display: flex;
    justify-content: flex-end
  }
  ::v-deep .v-toolbar__content {
    padding: 0 !important;
  }
  .startIconContainer {
    border: 1.3px solid #26384B;
    border-radius: 3px;
    width: 26px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ::v-deep table {
    padding: 0 20px;
  }
  .btn--container {
    position: fixed;
    width: 50px;
    height: 50px;
    background: rgba(38, 56, 75, 0.48);
    top: 50%;
    z-index: 50000000;
    border-radius: 50%;
  }
  ::v-deep .v-input--hide-details > .v-input__control > .v-input__slot {
    // center checkbox inside table cell
    justify-content: center;
  }
</style>

<style lang="scss">

  .VDataTable > .v-data-table__wrapper{
    max-height: 0 !important;
  }

  // improve display of footer with arrows pages
  @media screen and (max-width: 450px) {
    .VDataTable {
      .v-data-footer__select{
        display: flex;
        flex-direction: column;
      }
      .v-data-footer {
        display: flex;
        flex-direction: column;
        align-content: center;
      }
    }
  }

  @media screen and (max-width: 1258px) {
    .VDataTable {
      .v-data-table-header {
        top: 0;
        background-color: white;
        z-index: 2
      }
      .v-toolbar__content {
        z-index: 8
      }
      thead {
        z-index: 7
      }
      th {
        z-index: 3;
      }
      tbody, tbody * {
        z-index: 1;
      }
    }
  }

  @media screen and (max-width: 600px) {
    .titleBar {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  .sortTable{
      position: relative;
      .notranslate{
          position: absolute;
          right: -1px;
      }
  }


</style>
